export const getCommonHeaders = () => ({
  'content-type': 'application/json',
});
